import {
  AfterViewInit,
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {PopupServices} from "../../../services/popup.services";
import {Utils} from "../../../model/Utils";
import {MyTreeHelper} from "./helpers/MyTreeHelper";
import {TreeviewItem, TreeviewSelection} from "./models/treeview-item";

@Component({
  selector: 'tree',
  templateUrl: './TreeComponent.html',
  styleUrls: ['./TreeComponent.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TreeComponent),
      multi: true
    }
  ]
})

export class TreeComponent implements ControlValueAccessor, OnChanges{

  @Input()
  maxHeight = 600;
  @Input()
  selectFirstItemIfListHasOneElement= false;
  @Output()
  selectedChange = new EventEmitter<any[]>();

  public disabled = false;
  private _onTouchedCallback: any = () => {};
  private _onChangedCallback: any = () => {};

  public items = new Array<TreeviewItem>();

  selection: TreeviewSelection;
 // private  allItem: TreeviewItem; // I don't what is this thing for.

  constructor(
    @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
    @Inject(forwardRef(() => Router)) private router: Router,
    @Inject(forwardRef(() => SessionService)) private session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService
  ) {

  }

  public get hasFilterItems(){
    if (this.items){
      if (this.items.length>0){
        return true;
      }
    }
    return false;
  }


  writeValue(obj: any): void {
    // console.log('WriteValues ',obj)
    if (!obj){
      return;
    }
    this.items = obj;
    if (this.selectFirstItemIfListHasOneElement){
      this._selectFirstItem();
    }
  }
  registerOnChange(fn: any): void {
    this._onChangedCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouchedCallback = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private _selectChildren(item: TreeviewItem){
    item.checked = true;
    if (item.children){
      for (const childItem of item.children) {
        this._selectChildren(childItem);
      }
    }
  }

  private _selectFirstItem(){
    if (this.items && this.items.length===1){
      this._selectChildren(this.items[0]);
      this.onItemCheckedChange(null,false);
    }
  }



  ngOnChanges(changes: SimpleChanges): void {
  }



  onItemCheckedChange(item: TreeviewItem, checked: boolean): void {
    /*
    if (item instanceof FilterTreeviewItem) {
      item.updateRefChecked();
    }

     */

    this.updateCheckedOfAll();
    this.raiseSelectedChange();
  }

  private _getSelectedChange(component: TreeComponent): any[] {
    const checkedItems = component.selection.checkedItems;
    if (!Utils.isNullOrUndefined(checkedItems)) {
      return checkedItems.map(item => item.value);
    }

    return [];
  }

  raiseSelectedChange(): void {
    this.generateSelection();
    // const values = this.eventParser.getSelectedChange(this);
    const values = this._getSelectedChange(this);
    setTimeout(() => {
      this.selectedChange.emit(values);
    });
  }

  private generateSelection(): void {
    let checkedItems: TreeviewItem[] = [];
    let uncheckedItems: TreeviewItem[] = [];
    if (!Utils.isNullOrUndefined(this.items)) {
      const selection = MyTreeHelper.concatSelection(this.items, checkedItems, uncheckedItems);
      checkedItems = selection['checked'];
      uncheckedItems = selection['unchecked'];
    }

    this.selection = {
      checkedItems,
      uncheckedItems
    };
  }


  private updateCheckedOfAll(): void {
    let itemChecked: boolean = null;
    for (const filterItem of this.items) {
      if (itemChecked === null) {
        itemChecked = filterItem.checked;
      } else if (itemChecked !== filterItem.checked) {
        itemChecked = undefined;
        break;
      }
    }

    if (itemChecked === null) {
      itemChecked = false;
    }

    // this.allItem.checked = itemChecked;
  }

  private updateCollapsedOfAll(): void {
    let hasItemExpanded = false;
    for (const filterItem of this.items) {
      if (!filterItem.collapsed) {
        hasItemExpanded = true;
        break;
      }
    }

    // this.allItem.collapsed = !hasItemExpanded;
  }

}
